import React, { Fragment, useRef } from "react"
import PropTypes from "prop-types"
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useExpanded,
  usePagination,
} from "react-table"
import { Table, Row, Col, Button, Input, FormGroup, Label } from "reactstrap"
import { DefaultColumnFilter } from "components/Common/filters"
import { useEffect } from "react"
import { useState } from "react"
import JobListGlobalFilter from "components/Common/GlobalSearchFilter"
import Flatpickr from "react-flatpickr";
import { GetObjByMsgColor, MsgColors, UnBillsRentMakingStatus } from "_mock/Static_data"
import toast from "react-hot-toast"

// Define a default UI for filtering
function GlobalFilter({
  setGlobalFilter,
  isJobListGlobalFilter,
  filterData,
  value,
  setValue,
}) {
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined)
    filterData(value)
  }, 200)

  return (
    <React.Fragment>
      <div className="search-box  d-inline-block">
        <div className="position-relative">
          <label htmlFor="search-bar-0" className="search-label">
            <span id="search-bar-0-label" className="sr-only">
              Search this table
            </span>
            <input
              onChange={e => {
                setValue(e.target.value)
                onChange(e.target.value)
              }}
              id="search-bar-0"
              type="text"
              className="form-control"
              placeholder={"Search…"}
              value={value || ""}
            />
          </label>
          <i className="bx bx-search-alt search-icon"></i>
        </div>
      </div>
      {isJobListGlobalFilter && <JobListGlobalFilter />}
    </React.Fragment>
  )
}

const RentListTable = ({
  columns,
  data,
  isGlobalFilter,
  isJobListGlobalFilter,
  isAddRentAndMaking,
  handleRentMakingClick,
  className,
  filterData,
  pagePerSize,
  isLoading,
  TotalRecords,
  statusFilter, setStatusFilter,
  setDateFilter, dateFilter, users,
  userFilter, setUserFilter,
  setdateDisble, dateDisble,
  writeDataToExcel, setIsPending, setIsCall, isCall, isPending
  , TodaysPending, UnBillRentStatusCountList
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    gotoPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageSize: 20,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useExpanded,
    usePagination
  )
  const handlesort = column => { }
  const [pageIndex, setpageIndex] = useState(1)
  const [prevValue, setPrevValue] = useState();


  const generateSortingIndicator = column => {
    return column.isSorted ? (column.isSortedDesc ? "🔽" : "🔼") : ""
  }

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value))
  }

  const onChangeInInput = event => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0
    gotoPage(page)
  }

  const [isMobile, setisMobile] = useState(window.innerWidth < 924)
  const [value, setValue] = React.useState()
  const [displaySubAdmin, setDisplaySubAdmin] = useState(false)
  const [isIpad, setIsIpad] = useState(window.innerWidth < 924)
  const [TaskTitleTypes, setTaskTitleTypes] = useState(
    (JSON.parse(localStorage?.getItem("authUser")).TaskTitleTypes)
  )

  useEffect(() => {
    pagePerSize(pageSize, pageIndex, value)
    setPrevValue(value);
  }, [pageSize, value, pageIndex])

  useEffect(() => {
    if (value !== prevValue) {
      setpageIndex(1);
    }
  }, [value]);

  useEffect(() => {
    setpageIndex(1);
  }, [pageSize]);

  const margin = {
    marginTop: isMobile ? "" : "",
  }

  const handleClick = () => {
    setdateDisble(!dateDisble);
  }
  const checkbox = useRef();
  const flatpickrRef = useRef(null);

  useEffect(() => {
    if (!dateDisble) {
      document.getElementById("pendingRadio").checked = false;
      document.getElementById("callRadio").checked = false;
      document.getElementById("createdRadio").checked = true;
      setIsPending(false)
      setIsCall(false)
    }
  }, [dateDisble]);

  const handlePendingChange = (e) => {
    const value = e.target.checked;
    if (!dateDisble && value) {
      document.getElementById("pendingRadio").checked = false;
      document.getElementById("createdRadio").checked = true;
      toast.error("Please Select date", {
        icon: "⚠️",
        style: { fontSize: "15px" },
      });
    } else {
      setIsCall(false)
      setIsPending(value)
      document.getElementById("pendingRadio").checked = value;
    }
  };
  const handlerCallChange = (e) => {
    const value = e.target.checked;
    if (!dateDisble && value) {
      document.getElementById("callRadio").checked = false;
      document.getElementById("createdRadio").checked = true;
      toast.error("Please Select date", {
        icon: "⚠️",
        style: { fontSize: "15px" },
      });
    } else {
      setIsPending(false)
      setIsCall(value)
      document.getElementById("callRadio").checked = value;
    }
  };

  const handlerCreatedChange = (e) => {
    const value = e.target.checked;
    setIsPending(false)
    setIsCall(false)
    document.getElementById("createdRadio").checked = value;
  };

  const totalCount = UnBillRentStatusCountList.reduce((sum, item) => sum + item.StatusCount, 0);

  return (
    <Fragment>
      <Row>
        <Col md={9}>
          <Row>
            <Col md="2" className="table-header" >
              <select
                className="form-select"
                value={pageSize}
                onChange={onChangeInSelect}
              >
                {[10, 20, 30, 40, 50].map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            </Col>
            <Col md="3" className="table-header " style={{ marginTop: isMobile ? "5px" : "0px " }}>
              {isGlobalFilter && (
                <GlobalFilter
                  preGlobalFilteredRows={preGlobalFilteredRows}
                  globalFilter={state.globalFilter}
                  setGlobalFilter={setGlobalFilter}
                  isJobListGlobalFilter={isJobListGlobalFilter}
                  filterData={filterData}
                  value={value}
                  setValue={setValue}
                />
              )}
            </Col>

            {(TaskTitleTypes == null) &&
              <Col md="4" className="table-header" style={{ marginBottom: isMobile ? "10px" : '' }} >
                <Input
                  type="select"
                  id="validationCustom01"
                  className="form-control"
                  name="attendby"
                  // onChange={validation.handleChange}
                  onChange={e => {
                    setUserFilter(e.target.value)
                  }}
                  value={userFilter}
                >
                  <option value={0}>Select Attend By</option>
                  {users.map((item, index) => {
                    return (
                      <option key={index} value={item.Key}>
                        {item.Value}
                      </option>
                    )
                  })}
                </Input>
              </Col>
            }
            {(TaskTitleTypes != null && (TaskTitleTypes.includes("11") || TaskTitleTypes.includes("12"))) &&
              <Col md="4" className="table-header" style={{ marginBottom: isMobile ? "10px" : '' }} >
                <Input
                  type="select"
                  id="validationCustom01"
                  className="form-control"
                  name="attendby"
                  // onChange={validation.handleChange}
                  onChange={e => {
                    setUserFilter(e.target.value)
                  }}
                  value={userFilter}
                >
                  <option value={0}>Select Attend By</option>
                  {users.map((item, index) => {
                    return (
                      <option key={index} value={item.Key}>
                        {item.Value}
                      </option>
                    )
                  })}
                </Input>
              </Col>
            }
            <Col md="3" className="table-header" >
              <select
                className="form-select"
                value={statusFilter}
                onChange={e => setStatusFilter(e.target.value)}
              >
                <option value={0}>Status</option>
                {UnBillsRentMakingStatus.map((item, index) => {
                  return (
                    <option key={index} value={item.Value}>
                      {item.Key}
                    </option>
                  )
                })}
              </select>
            </Col>
          </Row>
          <Row>
            <div className="mb-1" style={{ gap: "22px", display: "flex", justifyContent: "start", textAlign: "center", marginLeft: "0px" }}>
              <FormGroup check>
                <Input
                  name="statusRadio"
                  id="createdRadio"
                  type="radio"
                  defaultChecked={isCall}
                  onChange={handlerCreatedChange}
                />
                <Label for="createdRadio" check>
                  Created
                </Label>
              </FormGroup>
              <FormGroup check>
                <Input
                  name="statusRadio"
                  id="callRadio"
                  type="radio"
                  defaultChecked={isCall}
                  onChange={handlerCallChange}
                />
                <Label for="callRadio" check>
                  Call Pending
                </Label>
              </FormGroup>
              <FormGroup check>
                <Input
                  name="statusRadio"
                  id="pendingRadio"
                  type="radio"
                  defaultChecked={isPending}
                  // checked={isPending}
                  onChange={handlePendingChange}
                />
                <Label for="pendingRadio" check>
                  Message Pending
                </Label>
              </FormGroup>
            </div>
            <Col md={6} className="" >
              <FormGroup className="mb-2">
                <div className="d-flex" >
                  <div className="form-control " onClick={() => handleClick()} style={{ width: "40px", borderRight: "none", backgroundColor: "#EFF2F7", display: "flex", alignItems: "center", cursor: "pointer" }}>
                    <input
                      id="checkbox"
                      type="checkbox"
                      style={{ width: "15px", height: "15px", cursor: "pointer" }}
                      checked={dateDisble}
                      onChange={e => setdateDisble(e.target.checked)}
                      ref={checkbox}
                    />
                  </div>
                  <Flatpickr
                    ref={flatpickrRef}
                    disabled={!dateDisble}
                    className="form-control d-block"
                    placeholder="dd M,yyyy"
                    options={{
                      mode: "range",
                      dateFormat: "d-m-Y"
                    }}
                    value={dateFilter}
                    onChange={(e) => { setDateFilter(e) }}

                  />
                  <i
                    className="fas fa-calendar-alt calander-icon"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      flatpickrRef.current.flatpickr.open();
                    }}
                  ></i>
                </div>
              </FormGroup>
            </Col>
            <Col md={(TaskTitleTypes != null && (TaskTitleTypes?.includes("12") || TaskTitleTypes.includes("11"))) ? 2 : 2}>
              <div style={{ marginTop: "", textAlign: isIpad ? "end" : "end", padding: isMobile ? '' : "0px" }}>
                {data.length > 0 ? (<button
                  type="button"
                  className="btn btn-excel  btn-label"
                  onClick={writeDataToExcel}
                >
                  Excel <i className="far fa-file-excel label-icon"></i>
                </button>) : (<button
                  type="button"
                  className="btn  btn-excel  btn-label"
                  style={{ cursor: "not-allowed" }}
                >
                  Excel <i className="far fa-file-excel label-icon"></i>
                </button>)}
              </div>
            </Col>

            {(TaskTitleTypes == null) &&
              <Col md={isMobile ? 5 : 2} style={{ marginTop: isIpad ? "3px" : "", marginBottom: isIpad ? "10px" : "" }}>
                <div className="d-flex" style={{ justifyContent: isIpad ? "end" : "end", gap: "15px", marginLeft: isIpad ? "6px" : "0px" }}>
                  <div className="text-sm-end">
                    <Button
                      type="button"
                      color="primary"
                      className="btn mb-2 "
                      onClick={handleRentMakingClick}
                    >
                      <i className="mdi mdi-plus-circle-outline me-1" />
                      Create
                    </Button>
                  </div>
                </div>
              </Col>}


            {TaskTitleTypes != null && ((TaskTitleTypes?.includes("11") || TaskTitleTypes.includes("12"))) &&
              <Col md={isMobile ? 5 : 2} style={{ marginTop: isIpad ? "3px" : "", marginBottom: isIpad ? "10px" : "" }}>
                <div className="d-flex" style={{ justifyContent: isIpad ? "end" : "end", gap: "15px", marginLeft: isIpad ? "6px" : "0px" }}>
                  <div className="text-sm-end">
                    <Button
                      type="button"
                      color="primary"
                      className="btn mb-2 "
                      onClick={handleRentMakingClick}
                    >
                      <i className="mdi mdi-plus-circle-outline me-1" />
                      Create
                    </Button>
                  </div>
                </div>
              </Col>
            }
          </Row>
          <Row></Row>
        </Col>
        <Col md={3} style={{ display: "flex", justifyContent: "end", marginBottom: "25px" }}>
          <table>
            {UnBillRentStatusCountList.map((item, index) => {
              const percentage = totalCount > 0 ? ((item.StatusCount / totalCount) * 100).toFixed(2) : "0.00";
              return (
                <tr style={{ fontWeight: "500", fontSize: "15px", marginRight: "12px" }} key={index}>
                  <td >{item.Status == 1 ? "Created" : item.Status == 2 ? "Convert" : "Fail"}</td>
                  <td>: <span style={{ color: item.Status == 1 ? "blue" : item.Status == 2 ? "green" : "Red", fontWeight: "500", fontSize: "15px", marginRight: "12px" }} >{item.StatusCount} ({percentage}%)</span></td>
                </tr>
              );
            })}
          </table>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <div style={{ display: "flex", gap: "20px", justifyContent: "end", marginBottom: "5px" }}>
            {MsgColors.map((item, index) => {
              return (
                <>
                  <div key={index}>
                    <div style={{ display: "flex", gap: "5px" }}>
                      <div style={{ width: '12px', height: '12px', backgroundColor: item.Value, marginTop: "3px", border: `1px solid ${item.Value}` }}>   </div> <div>{item.Key} </div>
                    </div>
                  </div>
                </>
              )
            })}
          </div>
        </Col>

      </Row>

      <div className="table-responsive react-table">
        <Table bordered  {...getTableProps()} className={className}>
          <thead className="table-light table-nowrap">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    key={column.id}
                    onClick={() => {
                      handlesort(column)
                    }}
                    className={` ${TaskTitleTypes != null && (column.Header == 'Action' && (!TaskTitleTypes.includes("12") && !TaskTitleTypes.includes("11")) ? 'column-display' : "")} `}
                    {...column.getHeaderProps({
                      style: {
                        minWidth: column.minWidth,
                        maxWidth: column.maxWidth,
                        width: column.width,
                      },
                    })}
                  >
                    <div className={`mb-0`}>
                      {column.render("Header")}
                      {generateSortingIndicator(column)}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          {page.length ? (
            <tbody {...getTableBodyProps()}>
              {page.map(row => {
                prepareRow(row)
                return (
                  <Fragment key={row.getRowProps().key}>
                    <tr>
                      {row.cells.map(cell => {
                        const { MsgNumber } = cell.row.original;
                        return (
                          <td
                            key={cell.id}
                            className={`text-nowrap ${TaskTitleTypes != null && ((cell.column.Header == 'Action') && (!TaskTitleTypes.includes("12") && !TaskTitleTypes.includes("11")) ? 'column-display' : "")} `}
                            // className={`text-nowrap`}
                            {...cell.getCellProps({
                              style: {
                                minWidth: cell.minWidth,
                                maxWidth: cell.maxWidth,
                                width: cell.width,
                                padding: '10px',
                                backgroundColor: GetObjByMsgColor(MsgNumber)[0]?.Color
                              },
                            })}
                          >
                            {cell.render("Cell")}
                          </td>
                        )
                      })}
                    </tr>
                  </Fragment>
                )
              })}
            </tbody>
          ) : (
            <tbody
              style={{
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                height: "40px",
              }}
            >
              <tr>
                <td colSpan={headerGroups[0].headers.length}>
                  {isLoading ? "Loading..." : "No Record Found"}
                </td>
              </tr>
            </tbody>
          )}
        </Table>
      </div>

      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              onClick={() => setpageIndex(pageIndex - 1)}
              disabled={pageIndex == 1}
            >
              {"<<"}
            </Button>
            {/* <Button
              color="primary"
              onClick={previousPage}
              // disabled={!canPreviousPage}
            >
              {"<"}
            </Button> */}
          </div>
        </Col>
        <Col className="col-md-auto d-none d-md-block">
          Page
          <strong style={{ marginLeft: "5px" }}>
            {TotalRecords == 0 ? 1 : pageIndex} of {TotalRecords == 0 ? 0 : Math.ceil(TotalRecords / pageSize)}
          </strong> | Total <strong>{TotalRecords}</strong>
        </Col>
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            {/* <Button color="primary" onClick={nextPage} disabled={!canNextPage}> */}
            {/* <Button color="primary" onClick={pageIndex}>
              {">"}
            </Button> */}
            <Button
              color="primary"
              onClick={() => setpageIndex(pageIndex + 1)}
              disabled={pageIndex == (pageIndex == 1 && TotalRecords == 0 ? Math.ceil(TotalRecords / pageSize) + 1 : Math.ceil(TotalRecords / pageSize))}
            >
              {">>"}
            </Button>
          </div>
        </Col>
      </Row>
    </Fragment>
  )
}

RentListTable.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default RentListTable
